import styled from '@emotion/styled'
import { DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'

const Paragraph = styled.p`
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-20']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-weight']};
  font-family: ${DEFAULT_FONT_STYLES['--theme-font--base-font-family']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-default__line-height']};
`

export default Paragraph
